<ngx-monaco-diff-editor
  [options]="codeOptions"
  [originalModel]="originalModel"
  [modifiedModel]="modifiedModel"
  (onInit)="onEditorInit($event)"
  [ngClass]="cssClass"
  [ngStyle]="cssStyle"
/>
